import { render } from "./DashboardSalesChart.vue?vue&type=template&id=fe67236e&scoped=true"
import script from "./DashboardSalesChart.vue?vue&type=script&lang=js"
export * from "./DashboardSalesChart.vue?vue&type=script&lang=js"

import "./DashboardSalesChart.vue?vue&type=style&index=0&id=fe67236e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe67236e"]])

export default __exports__